import { ShareholderRecord } from '../classes/shared';
import { calculateShareNumbersToBeSold } from './calculateSharesToBeSold';

// Modifies
export function deleteAmount({
  src,
  amount,
  eventRef,
  timeStamp,
}: {
  src: ShareholderRecord;
  amount: number;
  eventRef: string;
  timeStamp: number;
}): { newSrcRecord: ShareholderRecord } {
  const newSrcRecord: ShareholderRecord = { ...src };

  const amountnew = newSrcRecord.amount - amount;
  newSrcRecord.amount = amountnew;
  if (newSrcRecord.amount < 0) {
    newSrcRecord.amount = 0;
  }

  if (src?.numbers) {
    const { remainingNumbers } = calculateShareNumbersToBeSold({
      numbers: src.numbers,
      amount,
      eventRef,
      timeStamp,
    });

    newSrcRecord.numbers = remainingNumbers;
  }
  return { newSrcRecord };
}
